import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import MessageIfPresent from "@ignitesales/neuro-application/src/components/MessageIfPresent.jsx";
import Radio from "@ignitesales/neuro-application/src/components/questions/types/Radio.jsx";

const IconRadioButton = (props) => {
  const icon = (
    <MessageIfPresent id={`${props.appkey}.icon`}>
      <div className="text-center py-4 question__icon">
        <FormattedHTMLMessage id={`${props.appkey}.icon`} />
      </div>
    </MessageIfPresent>
  );

  return (
    <>
      {icon ? icon : null}
      <Radio {...props} type="radio" />
    </>
  );
};

export default IconRadioButton;
